<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-3"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-card
          class="mx-auto justify-center mb-1"
          max-width="500"
          style="margin-top: 50px;border-radius: 10px"
          :class="{'pa-6': !isMobile}"
          :elevation="(isMobile ? 0 : 10)"
          :flat="isMobile"
        >
          <v-row
            align="center"
            :class="{'mx-0' : !isMobile}"
            no-gutters
          >
            <v-col>
              <v-img
                class="mx-auto"
                width="250"
                src="@/assets/ready.jpg"
              />
            </v-col>
          </v-row>
          <v-row :class="{'mx-0' : !isMobile}">
            <v-card-title
              class="justify-start mt-4"
              grey
              style="width: 100%"
              darken-3
            >
              <h3>{{ $t('congratulation.yourCloudIsReady') }}</h3>
            </v-card-title>
            <v-card-title
              class="justify-start mt-4"
              grey
              style="width: 100%"
              darken-3
            >
              {{ $t('username') }} : {{phone}}
            </v-card-title>
            <v-col
              class="px-4  xs py-0 pt-8"
              cols="12"
            >
              <v-btn
                v-shortkey="['enter']"
                :loading="loading"
                block
                color="primary mr-0"
                @shortkey="login"
                @click="login"
              >
                <p
                  class="mb-0 mx-auto"
                  style="font-size: 18px"
                >
                  {{ $t('continue') }}
                </p>
                <v-icon
                  right
                  dark
                >
                  mdi-keyboard_return
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" />
          </v-row>
        </v-card>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    components: {
      Snakbar,
    },
    mixins: [General],
    props: ['lang', 'phone', 'password', 'shop'],
    data () {
      return {
        has_error: false,
        text_error: null,
        loading: false,
      }
    },
    beforeMount () {
      // this.$root.$i18n.locale = this.lang.lang
    },
    methods: {
      login () {
        this.$router.push({ name: 'login', params: { usernameProp: this.phone, lang: this.lang, passwordProp: this.password, shopProp: this.shop } })
        // this.$router.push({ name: 'login', params: { usernameProp: '09168144189', lang: this.lang, passwordProp: '9168144189', shopProp: true } })
      },
    },

  }
</script>

<style scoped>

</style>
